import React, { useEffect, useState } from 'react'
import { Col, Container, Nav, Row, Tab } from 'react-bootstrap'
import OrderCard from '../OrderCard/OrderCard'
import "./OrdersContainer.css"
import axios from 'axios'
import { useSelector } from 'react-redux'
function OrdersContainer() {
  const [ordersProccessing, setOrdersProccessing] = useState([])
  const [ordersShipped, setOrdersShipped] = useState([])
  const [ordersPending, setOrdersPending] = useState([])
  const [orderDelivered, setOrdersDelivered] = useState([])
    const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state);
  const [show, setShow] = useState(false);


  useEffect(() => {
    const getAllApis = async () => {
      await axios
        .get(`https://nanosoft.technology/outlaw/api/orders`,

          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.access_token}`
            }
          })

        .then(async (res) => {
          // setShow(true)
console.log(res.data.data);

          const filterPedig = res.data.data.filter(item => item.status.id==1);
          const filteredArray = res.data.data.filter(item => item.status.id==3);

          const filteredShippedArray = res.data.data.filter(item => item.status.id==4);

          const filteredDeliveredArray = res.data.data.filter(item => item.status.id==5);

          setOrdersPending(filterPedig);
          setOrdersProccessing(filteredArray);
          setOrdersShipped(filteredShippedArray)
          setOrdersDelivered(filteredDeliveredArray)
        })
        .catch((error) => {
          setShow(true)



        });
    }
    getAllApis()
  }, [])
  console.log(orderDelivered);
  
  return (
    <section className='Orders_container'>
      <h3>
                {currentLocal.home.myOrder}

      </h3>
      <div className='Orders_box'>

                   <Tab.Container defaultActiveKey="Pending">

            <Nav variant="tabs" defaultActiveKey="/Pending">
      <Nav.Item>
        <Nav.Link eventKey="Pending">{currentLocal.home.pending}</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="Processing">{currentLocal.home.proccing}</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="Shipped">{currentLocal.home.shipped}</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="Delivered">{currentLocal.home.delivered}</Nav.Link>
      </Nav.Item>
      <Nav.Item>

      </Nav.Item>
    </Nav>
    
      <Tab.Content className="mt-3">
        <Tab.Pane eventKey="Pending">
          <Container fluid>
                <Row>
                
                {ordersPending&&ordersPending.map((order,index)=>{
                  return(
                        <Col
                     md={6}
                    key={index}
                    >
                      
                    <OrderCard 
                    order={order}
                    status={'proccing'}
                    />
                  </Col>
                  )
                })}
         
      
                </Row>
              </Container>
      </Tab.Pane>
        <Tab.Pane eventKey="Processing">
          <Container fluid>
                <Row>
                
                {ordersProccessing&&ordersProccessing.map((order,index)=>{
                  return(
                        <Col
                     md={6}
                    key={index}
                    >
                      
                    <OrderCard 
                    order={order}
                    status={'proccing'}
                    />
                  </Col>
                  )
                })}
         
      
                </Row>
              </Container>
      </Tab.Pane>
        <Tab.Pane eventKey="Shipped">
              <Container fluid>
                <Row>
                
                {ordersShipped&&ordersShipped.map((order,index)=>{
                  return(
                  <Col
                     md={6}
                    key={index}
                    >
                      
                    <OrderCard 
                    order={order}
                    status={'shipped'}
                    />
                  </Col>
                  )
                })}
         
      
                </Row>
              </Container>

        </Tab.Pane>
        <Tab.Pane eventKey="Delivered">
              <Container fluid>
                <Row>
                {orderDelivered&&orderDelivered.map((order,index)=>{
                  return(
                    <Col
                     md={6}
                    key={index}
                    >
                      
                    <OrderCard 
                    order={order}
                    status={'shipped'}
                    />
                  </Col>
                  )
                })}
                </Row>
              </Container>


        </Tab.Pane>
      </Tab.Content>
      </Tab.Container>
      </div>
    </section >
  )
}

export default OrdersContainer